import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import ToolkitProvider, { Search,CSVExport  } from 'react-bootstrap-table2-toolkit';
import { NotificationManager } from "react-notifications";
import { Loader } from "../../../../components/loader";
import { NavLink } from "react-router-dom";
import moment from "moment";
import _  from 'lodash';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import classnames from 'classnames';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { fetchMedicalRecordsByAge } from '../../../../actions/medicalRecords';
import DatePicker from "react-datepicker";

const $ = window.$;
const orientation = window.matchMedia("(max-width: 700px)").matches ? 'vertical' : 'horizontal'
const { SearchBar } = Search;
const PUPPY_SENDING_STATUS = {
  completed : "completed",
  failed : "failed",
  pending : "pending"
}
class Coupon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user_role: "",
      couponData : [],
      selectedCalculateDate : moment().toDate()
    
    };
  }

  tableHeaderTopColumnData= [
    {
      dataField: "age",
      text: "Age",
      sort: true,   
    },
    {
      dataField: "count",
      text: "Count",
      sort: true,   
    },
  ];

  tableHeaderColumnData = [
    {
      dataField: "pet_id",
      text: "Pet ID",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span className="m-topbar__userpic">
            <img
              src={
                process.env.REACT_APP_S3_PATH +
                "/" +
                row.avatar_path +
                "/" +
                row.avatar_file_name
              }
              className="m--img-rounded m-width-50 mr-2"
              alt=""
            />           
            <span className="m-badge m-badge--info mx-auto my-0 px-2">
              <strong>{cell}</strong>
            </span>
                     
          </span>
        );
      }
    }, 
    {
      dataField: "breed",
      text: "Breed",
      sort: true
    },
    {
      dataField: "gender",
      text: "Gender",
      sort: true,
      formatter: cell => cell
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,   
      formatter: (cell,row) => {return <strong>{cell}</strong> } 
    }, 
    {
      dataField: "color",
      text: "Color",
      sort: true
    },
    {
      dataField: "dob",
      text: "Age", 
      sort: true,
      formatter: (cell, row)  => {
        return (
          <span>
            {row.ageWeek} Weeks, {row.ageDays} Days
          </span>
        )
      }
    },
    {
      dataField: "ghl_status",
      text: "GHL Status", 
      sort: true,
      formatter: (cell, row) => {
        return (
          <div>
          { row.ghl_status === PUPPY_SENDING_STATUS.completed ?
          <div>
          <span
            className={"m-badge mx-auto my-0 px-2 m-badge--success"}
          >
            <strong>Completed</strong>         
          </span> 
          </div>   
   
            :<div>
            {row.ghl_status === PUPPY_SENDING_STATUS.failed ?  
              <div>
                <span  className="m-badge mx-auto my-0 px-2 m-badge--danger mb-2">
                  <strong>Failed</strong>
                </span>  
              </div>
            :<div>     
            <span className="m-badge mx-auto my-0 px-1 m-badge--warning">
                <strong>Pending</strong> 
              </span>       
            </div>
            }                  
            </div>}  
          </div>
        );
      }
    },
    {
      dataField: "wooApi_status",
      text: "Woo Coupon Status", 
      sort: true,
      formatter: (cell, row) => {
        return (
          <div>
          { row.wooApi_status === PUPPY_SENDING_STATUS.completed ?
          <div>
          <span
            className={"m-badge mx-auto my-0 px-2 m-badge--success"}
          >
            <strong>Completed</strong>         
          </span> 
          </div>   
   
            :<div>
            {row.wooApi_status === PUPPY_SENDING_STATUS.failed ?  
              <div>
                <span  className="m-badge mx-auto my-0 px-2 m-badge--danger mb-2">
                  <strong>Failed</strong>
                </span>  
              </div>
            :<div>     
            <span className="m-badge mx-auto my-0 px-1 m-badge--warning">
                <strong>Pending</strong> 
              </span>       
            </div>
            }                  
            </div>}  
          </div>
        );
      }
    },
  ];

  expandRow = {
    renderer: (row, rowIndex) => (  
      <div>            
        <ToolkitProvider
          keyField="id"
          data={ row.puppies }
          columns={this.tableHeaderColumnData}
          search
          hover={true}
          filter={filterFactory()}                       
        >
        {props => (
          <div>                                              
            <BootstrapTable  
             classes="breedersPuppyChildTable"                          
             {...props.baseProps}          
            />  
           </div>                    
        )}
       </ToolkitProvider>  
      </div>
   ),
     showExpandColumn: true ,
     expandHeaderColumnRenderer: ({ isAnyExpands }) => {
             if (isAnyExpands) {
             return <b style={{cursor: 'pointer'}}><i className="fas fa-chevron-circle-up"></i></b>;
             }
             return <b style={{cursor: 'pointer'}}><i className="fas fa-chevron-circle-down"></i></b>;
           },
     expandColumnRenderer: ({ expanded }) => {
             if (expanded) {
               return (
                 <div style={{cursor: 'pointer', marginTop: '0px'}}><i className="fas fa-chevron-circle-up"></i></div>
               );
             }
             return (
               <div style={{cursor: 'pointer', marginTop: '0px'}}><i className="fas fa-chevron-circle-down"></i></div>
             );
           }
  };


  componentWillReceiveProps = nextProps => {  
    
    if (this.props.data.medicalRecordsReducer.medicalRecordListFilteredByAge !== nextProps.data.medicalRecordsReducer.medicalRecordListFilteredByAge) {
        this.setState({ couponData : nextProps.data.medicalRecordsReducer.medicalRecordListFilteredByAge, loading : false });  
   
    } 

    if (this.props.data.medicalRecordsReducer.medicalRecordListFilteredByAgeError !== nextProps.data.medicalRecordsReducer.medicalRecordListFilteredByAgeError) {
      this.setState({ loading : false });  
      NotificationManager.error("An error occured while loading the coupon puppies"); 
    }     
  };  


  componentDidMount() {
   const currentDate = moment().format('YYYY-MM-DD'); 
   this.props.fetchMedicalRecordsByAge(currentDate);
  }


  changeCalculateDate = value => {
    if(value){
    const selectedDate = moment(value).format('YYYY-MM-DD')
    this.setState({ selectedCalculateDate: value }); 
    this.props.fetchMedicalRecordsByAge(selectedDate);
    }
  }; 

  render() {
    const {  viewCustomer, couponData, selectedCalculateDate } = this.state;
    return (
      <div>     
          <div className="m-form m-form--label-align-right m--margin-top-20 m--margin-bottom-30">
            <div className="row align-items-center">
              <div className="col-xl-6 order-2 order-xl-1">
              </div>
              {/* Hide For Temporary */}
             {/* <div className="col-xl-6 order-1 order-xl-2 m--align-right">  
                <DatePicker
                  selected={selectedCalculateDate}
                  value={selectedCalculateDate}
                  onChange={this.changeCalculateDate}
                  onSelect={this.changeCalculateDate}
                />
                <br/>
                <div className="mt-2">
                 <span><p>Select the Date</p></span> 
                </div>                    
                <div className="m-separator m-separator--dashed d-xl-none"></div>
              </div>  */}
            </div>
          </div>
        {this.state.loading ?
          <div className="col-md-12" style={{ textAlign: 'center' }}>
            <Loader width="100px" height="100px;" />
          </div>
          :
          <ToolkitProvider
            keyField="id"
            data={couponData}
            columns={this.tableHeaderTopColumnData}
            search
            defaultSortDirection="asc"
            hover={true}       
          >
            {
              props => (
                <div>
                  <div className='px-0 mb-4 search-bar'>           
                   <div className='col-lg-3 px-0 inner-addon right-addon'>
                      <i className="fas fa-search"></i>
                      <SearchBar {...props.searchProps} />
                    </div>
                  </div>
                  <BootstrapTable
                    classes="petTable"
                    {...props.baseProps}              
                    expandRow={ this.expandRow }                         
                  />
                </div>
              )
            }
          </ToolkitProvider>
        }

      </div>

    );
  }
}
  const mapStateToProps = state => ({
    user: state.cognito.user,
    petShop: state.petShopReducer,
    data: state,
    currentUser: state.userReducer.currentUser
  });

  const mapDispatchToProps = dispatch => ({
    fetchMedicalRecordsByAge: (selectedDate) => {
     dispatch(fetchMedicalRecordsByAge(selectedDate));
    }
  });

  export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Coupon)
  );